export default "__VITE_ASSET__Bg3Taveu__"